import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_comp_ext_RowClass} from '../../dbschema/bl_fi_mst_comp_ext.model';

export class CompanyExtensionContainerModel extends BaseContainerModel {
  bl_fi_mst_comp_ext: bl_fi_mst_comp_ext_RowClass = new bl_fi_mst_comp_ext_RowClass();
}
